// The delivery city the buyer picked, remembered for 30 days.
export const CITY_STORAGE_KEY = "fl_city_choice";

export const rememberCity = (city) => {
  try {
    localStorage.setItem(CITY_STORAGE_KEY, JSON.stringify({ key: city.key, slug: city.slug, name: city.name, at: Date.now() }));
  } catch { /* ignore quota */ }
};

export const skipCity = () => {
  try {
    localStorage.setItem(CITY_STORAGE_KEY, JSON.stringify({ key: "_skipped", at: Date.now() }));
  } catch { /* ignore quota */ }
};

export const readCityChoice = () => {
  try {
    const raw = localStorage.getItem(CITY_STORAGE_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    if (!v?.at || Date.now() - v.at > 30 * 24 * 60 * 60 * 1000) return null;
    return v;
  } catch { return null; }
};
